import { endOfDay, isAfter } from 'date-fns';
import { InvoiceV2 } from '../api/portal-invoices.api';

export const isInvoicePastDue = (invoice: InvoiceV2) => {
    return invoice.dueDate ? !isAfter(endOfDay(invoice.dueDate), new Date()) : false;
};

export const getDaysUntilDue = (invoice: InvoiceV2) => {
    if (!invoice.dueDate || isInvoicePastDue(invoice)) {
        return 0;
    }
    const now = new Date();
    const due = invoice.dueDate;
    const diff = due.getTime() - now.getTime();
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export const showOverdueTag = (invoice: InvoiceV2) => {
    return invoice.balance > 0 && isInvoicePastDue(invoice);
};
